export const currency = (number, local, symbol) => {
	if (!number || !local || !symbol) return null
	return new Intl.NumberFormat(local, { style: 'currency', currency: symbol }).format(number)
}



// WEBPACK FOOTER //
// ./src/filters/index.js